/* cbp-cart.js - theme-agnostic add-to-cart helper for the cloned product page.
   Adds the line, re-renders the theme's own cart drawer + header via the
   Section Rendering API, then opens the drawer using the theme's own trigger.
   Falls back to /cart whenever a drawer cannot be found or refreshed. */
window.CBPCart = (function () {
  function trigger() {
    return document.querySelector('[data-testid="cart-drawer-trigger"]')
        || document.querySelector('[aria-controls="cart-drawer"]')
        || (document.querySelector('cart-icon') && document.querySelector('cart-icon').closest('a,button'))
        || null;
  }

  function sectionId(wrap) {
    return wrap ? wrap.id.replace('shopify-section-', '') : null;
  }

  function refreshAndOpen() {
    var drawerWrap = document.querySelector('[id^="shopify-section"][id*="cart-drawer"]');
    var t0 = trigger();
    var headWrap = t0 ? t0.closest('[id^="shopify-section"]') : null;

    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));

    var ids = [sectionId(drawerWrap), sectionId(headWrap)].filter(Boolean);
    if (!ids.length) { window.location.href = '/cart'; return; }

    fetch('/?sections=' + ids.map(encodeURIComponent).join(','))
      .then(function (r) { return r.json(); })
      .then(function (data) {
        function swap(wrap) {
          if (!wrap) return;
          var html = data[sectionId(wrap)];
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.getElementById(wrap.id) || doc.body.firstElementChild;
          if (fresh) wrap.innerHTML = fresh.innerHTML;
        }
        swap(drawerWrap);
        swap(headWrap);
        var t = trigger();
        if (t) { t.click(); } else { window.location.href = '/cart'; }
      })
      .catch(function () { window.location.href = '/cart'; });
  }

  function add(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add-to-cart failed');
      return r.json();
    }).then(function (res) {
      refreshAndOpen();
      return res;
    });
  }

  return { add: add, refreshAndOpen: refreshAndOpen, trigger: trigger };
})();
